import React, { Component } from 'react';
import { triggerIntroReveal } from '../App';

import Title from '../../components/navigation/Title'
import Hero from '../../components/hero/Hero.js'
// import Shutter from '../../components/hero/transitions/Shutter'

import BigImage from '../../components/pageContent/BigImage.js'


class Page extends Component {

	componentDidMount() {
		if (this.props.onPageReady) {
			this.props.onPageReady();
		}
		triggerIntroReveal();
	}
	
	render() {

		const { viewport } = this.props

		const data = {
			fields: {
				title: "A title",
				file: {
					url: "/images/1.jpg"
				}
			}
		}
		
		return (
			<div>

				<Title text="OOOoops" />

                <Hero title="OOOoops" subtitle="Something went wrong" color="#f69679" theme="light" viewport={viewport} isCentered={true}
                    media={false}
                    background={<BigImage data={data} />}
                    showScroll={false}
                />

			</div>
		);
	}
}

export default Page;